import InputSerialNumber from "./components/InputSerialNumber";
import CprResults from "./components/Results/CprResultsView";

const routes = [
  { path: '/', component: InputSerialNumber },
  { path: '/input-serial', component: InputSerialNumber },
  { path: '/cpr-results', component: CprResults },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js